const initialState = {
  index: [],
  data: {},
};

const Marketing = (state = initialState, action) => {
  switch (action.type) {
    case "MARKETING_INDEX":
      return { ...state, index: action.payload.index };
    case "MARKETING_DATA":
      return { ...state, data: action.payload.data };
    case "MARKETING_RESET":
      return initialState;
    default:
      return state;
  }
};

export default Marketing;
